import { Pipe, PipeTransform} from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {

  public transform(value: string | number | Dayjs, format?: string): string {
    if (value === null || value === undefined) {
      return null;
    }

    if (value === '') {
      value = dayjs();
    }

    const dayjsValue = typeof value === 'string' || typeof value === 'number' ? dayjs(value) : dayjs(value);

    return dayjsValue.format(format || environment.servicesDateFormat);
  }
}
